import React, { CSSProperties } from "react";
import cx from "classnames";
import styles from "./fieldset-error.module.scss";

export interface IFieldsetError {
  children?: React.ReactNode;
  className?: string;
  style?: CSSProperties;
  htmlId?: string;
}

export const FieldsetError = (props: IFieldsetError) => {
  return (
    <span className={cx(styles.fieldset_error, props.className)} style={props.style} id={props.htmlId}>
      {props.children}
    </span>
  );
};

FieldsetError.defaultProps = {};
